import api from '@/apis'
import * as TYPES from './mutationTypes'

export default {
  getRecordtLists({ commit }, params) {
    return api.crossChain
      .getRecordtList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_CROSS_CHAINRECORD, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  }
}
